// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","dueTrainingIcon":"HomeTransition_dueTrainingIcon__oVZD4"};